module.exports = __webpack_public_path__ + "img/lemon_blueberry-min.b9832508.jpg";